import { Box, Heading, VStack, motion } from '@hover/blueprint';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import { LoadingTextEllipsis } from 'src/modules/homeownerApp/components/LoadingText';
import { UploadImageBox } from 'src/modules/homeownerApp/components/UploadImage/UploadImageBox';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type CreatingProjectLoadingProps = {
  imageUrl?: string;
};

const MotionVStack = motion(VStack);

export const CreatingProjectLoading = ({
  imageUrl,
}: CreatingProjectLoadingProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  if (!imageUrl) return null;

  return (
    <VStack
      alignItems="center"
      backgroundColor="neutral.0"
      bottom={0}
      flex={1}
      justifyContent="center"
      left={0}
      position="absolute"
      right={0}
      top={0}
      zIndex="loading"
    >
      <AnimatePresence>
        <MotionVStack animate={{ opacity: 1 }} initial={{ opacity: 0 }}>
          <UploadImageBox
            imageUrl={imageUrl}
            maxW={{ base: '80%', tablet: 'min(500px, 80%)' }}
          />
          <Box
            alignItems="center"
            flexDir="column"
            mt={{ base: '700 !important', tablet: '900 !important' }}
          >
            <Heading
              mb={0}
              textStyle={{ base: 'headingMedium', tablet: 'headingXl' }}
            >
              {t('projects.projectCreation.creatingProject')}
            </Heading>
            <Heading textStyle={{ base: 'headingMedium', tablet: 'headingXl' }}>
              <LoadingTextEllipsis />
            </Heading>
          </Box>
        </MotionVStack>
      </AnimatePresence>
    </VStack>
  );
};
